export default __webpack_public_path__ + "static/media/crystl.8bf8df1d.svg";